import axios from "axios";
import _BaseAPIService from "../_BaseAPIService";

// Create axios instance with api4 base URL
const apiServiceInstance = axios.create({
  baseURL: "https://api-databasewebservice.danfesolution.com",
});

const AdLogService = {
  // Log ad impression/interaction
  logAdImpression: async (adLog) => {
    try {
      const response = await apiServiceInstance.post(
        "/api/itouch/ad-logs/batch",
        adLog,
        {
          headers: {
            Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        },
      );
      console.log("🚀 ~ AdLogService ~ Ad logged:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error logging ad impression:", error);
      throw error;
    }
  },

  // Fetch ads by MAC address for swiper and video
  getAdsByMacAddress: async (macId) => {
    try {
      const response = await apiServiceInstance.get(
        `/api/devicesads/by-mac/${macId}`,
        {
          headers: {
            Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        },
      );
      console.log("🚀 ~ AdLogService ~ Ads fetched by MAC:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching ads by MAC address:", error);
      throw error;
    }
  },

  getLogDurationInMinutes: async (macId) => {
    try {
      console.log("called")
      const response = await apiServiceInstance.get(
        `/api/org-devices/by-mac/${macId}`,
        // {
        //   headers: {
        //     Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
        //   },
        // },
      );
      console.log(
        "🚀 ~ AdLogService ~ Org devices fetched by MAC:",
        response.data,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching org devices by MAC address:", error);
      throw error;
    }
  },
};

export default AdLogService;
